import { type CSSProperties } from 'react';
import styles from './Loader.module.css';

interface ILoaderProps {
  /** Side length in px. Mirrors trusstor's prop shape. Default 30. */
  size?: number;
  /** Convenience for the trusstor `big` variant — equivalent to `size={60}`. */
  big?: boolean;
  className?: string;
}

/**
 * Pure-CSS rotating ring loader. Replicates trusstor's `shared/components/
 * Loader` so screens that need a busy indicator can drop one in without
 * thinking about animation, palette, or accessibility framing. The visual
 * is decorative — callers wrap it in a parent that carries the a11y
 * signal (e.g. `role="status"` + `aria-busy="true"`).
 */
export function Loader({ size = 30, big = false, className }: ILoaderProps) {
  const side = big ? 60 : size;
  const style: CSSProperties = { width: side, height: side };
  const cls = className ? `${styles.loading} ${className}` : styles.loading;
  return <div className={cls} style={style} aria-hidden="true" />;
}
